import {
  CameraChangeLens,
  CameraGimbal,
  CameraLiveView,
  FlightControlBrake,
  FlightControlGoto,
  FlightControlReturnHome,
  FlightControlStickControl,
  FlightControlTakeoff,
  FlightControlTakeoffSimulation,
  MissionClear,
  MissionLoad,
  MissionPause,
  MissionResume,
  MissionStart,
  MissionUpload,
  MissionUploadSimulation,
  RemoteDebugAircraftCharge,
  RemoteDebugAircraftPower,
  RemoteDebugDebugMode,
  RemoteDebugDockCanopy,
  RemoteDebugDockRestart,
} from '@/define/commandSet/dji';

const commandGroups = [
  {
    name: 'Flight Control',
    commands: [
      FlightControlTakeoff,
      FlightControlTakeoffSimulation,
      FlightControlGoto,
      FlightControlStickControl,
      FlightControlBrake,
      FlightControlReturnHome,
    ],
  },
  {
    name: 'Camera',
    commands: [CameraLiveView, CameraChangeLens, CameraGimbal],
  },
  {
    name: 'Mission',
    commands: [
      MissionLoad,
      MissionUpload,
      MissionUploadSimulation,
      MissionStart,
      MissionPause,
      MissionResume,
      MissionClear,
    ],
  },
  {
    name: 'Remote Debug',
    commands: [
      RemoteDebugDebugMode,
      RemoteDebugAircraftCharge,
      RemoteDebugAircraftPower,
      RemoteDebugDockCanopy,
      RemoteDebugDockRestart,
    ],
  },
];

export default commandGroups;
